import actionTypes from '../actions/actionsFactory/types';

const {
  SET_GOOGLE_AUTH_SECRET_KEY_DATA,
  FETCH_COUNTRY_SHORT_NAME_SUCCESS,
  FETCH_TRADE_INFO_SUCCESS,
  FETCH_USER_TOTAL_COMMISSTION_SUCCESS,
  FETCH_USER_DEVICE_LIST_SUCCESS,
  FETCH_USER_DEVICE_LOG_SUCCESS,
  DELETE_USER_DEVICE_SUCCESS,
  UPDATE_USER_PASSWORD,
  FETCH_ACCOUNT_ACTIVITY_RECORD_SUCCESS,
  SET_TRADE_LEVEL_INFO,
  SET_TOP_COMMISSION,
  FETCH_USER_COMMISSTION_TOTAL,
  FETCH_USER_COMMISSTION_FIAT_TOTAL,
  FETCH_USER_REFERRAL_FRIENDS,
  FETCH_USER_COMMISSTION_DETAIL,
  FETCH_USER_REFERRAL_MONTHLY,
  SET_ACTIVITY_INFO,
  SET_MY_REFERRAL_REWARD_LIST
} = actionTypes;

export const INITIAL_STATE = {
  googleAuthSecretKeyData: {},
  countryShortName: '',

  userTotalCommission: 0,
  userDeviceList: [],
  userDeviceLog: {},
  userUpdatePasswordData: {},
  tradeLevelInfo: {},
  topCommission: [],
  commissionTotal: {},
  commissionFiatTotal: {},
  agents: [],
  commissions: [],
  activityInfo: {},
  myReferralRewardList: {
    referralRewardList: []
  }
};

const _handleDeleteDeviceSuccess = (state, id) => {
  const { userDeviceList } = state;
  const newUserDeviceList = userDeviceList.filter(item => item.id !== id);
  return { ...state, userDeviceList: newUserDeviceList };
};

export const reducer = (state, action) => {
  switch (action.type) {
    case SET_GOOGLE_AUTH_SECRET_KEY_DATA:
      return { ...state, googleAuthSecretKeyData: { ...action.data } };
    case FETCH_COUNTRY_SHORT_NAME_SUCCESS:
      return { ...state, countryShortName: action.data };
    case FETCH_TRADE_INFO_SUCCESS:
      return { ...state, userTradeInfo: (action.data || {}) };
    case FETCH_USER_TOTAL_COMMISSTION_SUCCESS:
      return { ...state, userTotalCommission: action.data };
    case FETCH_USER_DEVICE_LIST_SUCCESS:
      return { ...state, userDeviceList: action.data.data, userDeviceTotal: action.data.total };
    case FETCH_USER_DEVICE_LOG_SUCCESS:
      return {
        ...state,
        userDeviceLog: { ...state.userDeviceLog, [action.data.id]: action.data.data },
      };
    case DELETE_USER_DEVICE_SUCCESS:
      return _handleDeleteDeviceSuccess(state, action.data);
    case UPDATE_USER_PASSWORD:
      return { ...state, userUpdatePasswordData: action.data };
    case FETCH_ACCOUNT_ACTIVITY_RECORD_SUCCESS:
      return { ...state, accountActivityRecord: action.data };
    case SET_TRADE_LEVEL_INFO:
      return { ...state, tradeLevelInfo: action.data };
    case SET_TOP_COMMISSION:
      return { ...state, topCommission: Array.isArray(action.data) ? action.data : [] };
    case FETCH_USER_COMMISSTION_TOTAL:
      return { ...state, commissionTotal: action.data };
    case FETCH_USER_COMMISSTION_FIAT_TOTAL:
      return { ...state, commissionFiatTotal: action.data };
    case FETCH_USER_REFERRAL_FRIENDS:
      return { ...state, agents: action.data?.agents || [] };
    case FETCH_USER_COMMISSTION_DETAIL:
      return { ...state, commissions: action.data?.commissions || [] };
    case FETCH_USER_REFERRAL_MONTHLY:
      return { ...state, referralMonthly: action.data || [] };
    case SET_ACTIVITY_INFO:
      return { ...state, activityInfo: action.data || {} };
    case SET_MY_REFERRAL_REWARD_LIST:
      return { ...state, myReferralRewardList: {
        ...action.data,
        referralRewardList: [...state.myReferralRewardList.referralRewardList, ...action.data.referralRewardList]
      }};
    default:
      return state;
  }
};
